export default "__VITE_ASSET__CcAfRmu8__"